/* unplugin-vue-components disabled */import script from "./TeachingCourses.vue?vue&type=script&setup=true&lang=js"
export * from "./TeachingCourses.vue?vue&type=script&setup=true&lang=js"

import "./TeachingCourses.vue?vue&type=style&index=0&id=83ee5f8e&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户广西-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83ee5f8e"]])

export default __exports__